import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

/**
 * Hook that wraps useNavigate to automatically prepend /fleet prefix
 * for fleet mode routes.
 *
 * Usage:
 *   const navigate = useFleetNavigate();
 *   navigate("/dashboard") -> navigates to "/fleet/dashboard"
 *   navigate("..") -> relative navigation, no prefix added
 *
 * @returns {Function} navigate function with /fleet prefix for absolute paths
 */
export const useFleetNavigate = () => {
    const navigate = useNavigate();

    return useCallback(
        (to, options) => {
            // If path is relative (doesn't start with /), use as-is
            if (typeof to === "string" && !to.startsWith("/")) {
                return navigate(to, options);
            }

            // If path is absolute and doesn't already have /fleet prefix, add it
            if (typeof to === "string" && to.startsWith("/") && !to.startsWith("/fleet")) {
                return navigate(`/fleet${to}`, options);
            }

            // Otherwise use as-is (already has /fleet, or is a number for delta navigation)
            return navigate(to, options);
        },
        [navigate]
    );
};
